import axiosInstance from "../utils/axiosInstance";

export const fetchLatestNotifications = async () => {
    try {
        const response = await axiosInstance.get(`/api/notifications/latest`);
        return response.data;
    } catch (error) {
        console.error('Error fetching latest notifications:', error);
        return {
            "data": [],
            "unread_count": 0
        };
    }
};

export const fetchNotifications = async () => {
    try {
        const response = await axiosInstance.get(`/api/notifications`);
        return response.data;
    } catch (error) {
        console.error('Error fetching notifications:', error);
        return [];
    }
};

export const readNotification = (notificationId) => {
    try {
        const response = axiosInstance.post(`/api/notifications/read/${notificationId}`);
        return response.data;
    } catch (error) {
        console.error('Error read notification:', error);
        return [];
    }
};


export function formatDate(dateString) {
    const date = toLocalDate(dateString);
    const now = new Date();

    const isToday =
        date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear();

    if (isToday) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    return date.toLocaleDateString([], {
        day: 'numeric',
        month: 'short',
    });
};

export function toLocalDate(dateString) {
    return new Date(dateString.replace(" ", "T") + "Z");
}